gsap.registerPlugin(
  ScrollTrigger
);

function isMobile(){
  return window.matchMedia("(max-width:767px)").matches;
}
function isTablet(){
  return window.matchMedia("(min-width:768px) and (max-width:991px)").matches;
}
function isDesktop(){
  return window.matchMedia("(min-width:992px)").matches;
}
function initGalleryOverlayTransitionFlip() {  
    
  const listItems = document.querySelectorAll(".main-title__item");
  const imageItems = document.querySelectorAll(".main-img__item");
  const overlayItems = document.querySelectorAll(".overlay-item");
  // const overlayNav = document.querySelector(".overlay-nav");
  let animating = false;
  
  let lastZindex = 1;
  let lastHoveredIndex = null;

  // Remove active class from all items
  const removeActiveClass = () => {
    listItems.forEach(item => item.classList.remove('active'));
  };

  listItems.forEach((listItem, i) => {
    listItem.addEventListener("mouseenter", () => {
      if(animating || lastHoveredIndex === i) return;
      animating = true;
      lastHoveredIndex = i;
      
      // Remove active class from all and add to current
      removeActiveClass();
      listItem.classList.add('active');
      
      setTimeout(() => {
        animating = false;
      }, 100);
      
      lastZindex++;
      gsap.set(imageItems[i], {
        zIndex: lastZindex
      })
      gsap.fromTo(imageItems[i], {
        clipPath: "inset(100% 0 0 0)",
        scale: 1,
        // opacity:0,
      }, {
        opacity:1,
        clipPath: "inset(0% 0 0 0)",
        scale: 1,
        duration: 1,
        ease: "power3.out"
      });

    }); 
  });
}
function initSwiper() {
let sliders = document.querySelectorAll('[swiper]');
sliders.forEach(function(slider) {

  const mobileSlides = slider.getAttribute('s_p_s_m');
  let tabSlides = slider.getAttribute('s_p_t');
if(!tabSlides) tabSlides = "auto";

  // Check if slider should be initialized
  if (mobileSlides === '0' && isMobile()) {
    return;
  }
  if(!slider.querySelector(".swiper-wrapper")){
    return;
  }
  let prev = slider.querySelector("[button-prev]");
  let next = slider.querySelector("[button-next]");
  let gap = parseInt(window.getComputedStyle(slider.querySelector(".swiper-wrapper")).columnGap) || 30;
  slider.querySelector(".swiper-wrapper").style.setProperty("column-gap",0)
  const swiper = new Swiper(slider.querySelector(".swiper"), {
    slidesPerView: "auto",
    spaceBetween: gap,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: mobileSlides,
      },
      768: {
        slidesPerView: tabSlides,
      },
      992: {
        slidesPerView: "auto",
      }
    },
    navigation: {
      nextEl: next,
      prevEl: prev
    }
  });
});
}
// faq navbar
function initProgressNavigation() {
  const navProgress = document.querySelector('[data-progress-nav-list]');
  if (!navProgress) return;

  // Create or select the moving indicator
  let indicator = navProgress.querySelector('.progress-nav__indicator');
  if (!indicator) {
    indicator = document.createElement('div');
    indicator.className = 'progress-nav__indicator';
    navProgress.appendChild(indicator);
  }

  // Safely select the first nav target
  const firstNavTarget = navProgress.querySelector('[data-progress-nav-target]');
  if (!firstNavTarget) {
    console.warn('[initProgressNavigation] No [data-progress-nav-target] elements found.');
    return;
  }

  // Initialize indicator size and position
  const updateIndicator = (activeLink) => {
    if (!activeLink || !indicator) return;

    const parentRect = navProgress.getBoundingClientRect();
    const linkRect = activeLink.getBoundingClientRect();

    const left = linkRect.left - parentRect.left;
    const top = linkRect.top - parentRect.top;
    const width = linkRect.width;
    const height = linkRect.height;

    // Use GSAP for smooth updates
    gsap.to(indicator, {
      left: left,
      top: top,
      width: width,
      height: height,
      duration: 0.4,
      ease: 'power2.out'
    });
  };

  // Set initial active state
  firstNavTarget.classList.add('is--active');
  updateIndicator(firstNavTarget);

  // Handle scroll triggers
  const progressAnchors = gsap.utils.toArray('[data-progress-nav-anchor]');
  if (!progressAnchors.length) {
    console.warn('[initProgressNavigation] No [data-progress-nav-anchor] sections found.');
  }

  progressAnchors.forEach((anchor) => {
    const anchorID = anchor.getAttribute('id');
    if (!anchorID) return;

    ScrollTrigger.create({
      trigger: anchor,
      start: '0% 50%',
      end: '100% 50%',
      onEnter: () => activateLink(anchorID),
      onEnterBack: () => activateLink(anchorID)
    });
  });

  function activateLink(id) {
    const activeLink = navProgress.querySelector(`[data-progress-nav-target="#${id}"]`);
    if (!activeLink) return;

    // Update active classes
    navProgress.querySelectorAll('[data-progress-nav-target]').forEach(link => {
      link.classList.toggle('is--active', link === activeLink);
    });

    updateIndicator(activeLink);
  }
}

// Q&A code
function initAccordionCSS() {
  document.querySelectorAll('[data-accordion-css-init]').forEach((accordion) => {
    const closeSiblings = accordion.getAttribute('data-accordion-close-siblings') === 'true';

    accordion.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-accordion-toggle]');
      if (!toggle) return; // Exit if the clicked element is not a toggle

      const singleAccordion = toggle.closest('[data-accordion-status]');
      if (!singleAccordion) return; // Exit if no accordion container is found

      const isActive = singleAccordion.getAttribute('data-accordion-status') === 'active';
      singleAccordion.setAttribute('data-accordion-status', isActive ? 'not-active' : 'active');
      
      // When [data-accordion-close-siblings="true"]
      if (closeSiblings && !isActive) {
        accordion.querySelectorAll('[data-accordion-status="active"]').forEach((sibling) => {
          if (sibling !== singleAccordion) sibling.setAttribute('data-accordion-status', 'not-active');
        });
      }
    });
  });
}

function footerToggles() {
    if (window.innerWidth >= 768) {
      return;
    }

    let footer_labels = [...document.querySelectorAll(".footer-l-title")];
    
    footer_labels.forEach(footer_label => {
      let next_element = footer_label.nextElementSibling;
      next_element.style.setProperty("--data-height", next_element.scrollHeight + "px");
      next_element.style.setProperty("height", "0px");
      footer_label.addEventListener("click", function () {
        footer_labels.forEach(element => {
          if (element !== footer_label) {
            element.classList.remove("active");
          }
        });

        footer_label.classList.toggle("active");
      });

    });
  }

  function megamenuSubitems() {

    let megamenuSubitems = [...document.querySelectorAll(".mega-menu-sub")];
    
    megamenuSubitems.forEach(megamenuSubitem => {
      megamenuSubitem.style.setProperty("--data-height", megamenuSubitem.scrollHeight + "px");
      megamenuSubitem.style.setProperty("height", "0px");
    });
    let megamenu_right = [...document.querySelectorAll(".megamenu-right")];
    megamenu_right.forEach(megamenu_right => {
      megamenu_right.style.setProperty("--menu-height", megamenu_right.scrollHeight + "px");
    });
  }

  function headerHideShow(){
    let header = document.querySelector(".header");
    let lastScrollTop = 0;
    const delta = 5;
    let dvh = window.innerHeight;
    dvh = dvh - header.offsetHeight - 20;
    window.addEventListener("scroll", function () {
      let scrollTop = window.scrollY;
      let scrollTohide = dvh + 300;
      if (scrollTop > dvh) {
       header.classList.add("is-hide");
      } else {
        header.classList.remove("is-hide");
      }
      if(scrollTop > 100){
        header.classList.add("hide-announcement");
      } else {
        header.classList.remove("hide-announcement");
      }
    });


    function handleScroll() {
        const currentScroll = window.scrollY;
        let scrollThreshold = dvh + 300;

        if (Math.abs(currentScroll - lastScrollTop) <= delta) return;

        if (currentScroll > scrollThreshold && currentScroll > lastScrollTop) {
            header.classList.add('hide-header');
        } else {
            header.classList.remove('hide-header');
        }

        document.body.classList.toggle('is-header-scrolled', currentScroll >= scrollThreshold);
        lastScrollTop = currentScroll;
    }

    window.addEventListener('scroll', handleScroll);

  }

  function initLenis(){

          window.locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
        lerp: 0.1,
        duration: 0.8,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        normalizeWheel: true,
        autoResize: false,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    },
});

    
  }

  function initrotateonScroll(){
    let rotatElements = document.querySelectorAll(".sustainability-circle");
    rotatElements.forEach(element => {
      window.addEventListener("scroll", function () {
        let scrollTop = window.scrollY;
        scrollTop = scrollTop * -0.3;
        element.style.transform = `rotate(${scrollTop}deg)`;
      });
    });
  }

  function scrollMore(){
    let scrollMore = document.querySelector(".scroll-more");
    if(!scrollMore) return;
    scrollMore.addEventListener("click", function () {
      let scrollTop = 0;
      let dvh = window.innerHeight;
      window.scrollTo({
        top: scrollTop + dvh,
        behavior: 'smooth'
      });
    });
  }
function initHighlightText(){
  let splitHeadingTargets = document.querySelectorAll("[highligh_text]");
  
  splitHeadingTargets.forEach((section) => {
    let heading = section.querySelector(".o-section-header-i .h2");
    if (!heading) return;
    const fadedValue = heading.getAttribute("data-highlight-fade") || 0.2;
    const staggerValue = heading.getAttribute("data-highlight-stagger") || 0.1;
    
    let words = heading.querySelectorAll(".word");
    let tl = gsap.timeline({
      scrollTrigger: {
        scrub: 0.5,               // slower scrub for smoother linger
        trigger: section,
        start: "top+=30% bottom",
        end: "bottom bottom+=30%"
      }
    });
    tl.to(words, {
      opacity: 1,
      stagger: staggerValue,
      ease: "linear"
    });
  });
}

function initContentRevealScroll(){
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ctx = gsap.context(() => {

    document.querySelectorAll('[data-reveal-group]').forEach(groupEl => {
      // Config from attributes or defaults (group-level)
      const groupStaggerSec = (parseFloat(groupEl.getAttribute('data-stagger')) || 100) / 1000; // ms → sec
      const groupDistance = groupEl.getAttribute('data-distance') || '2em';
      const triggerStart = groupEl.getAttribute('data-start') || 'top 80%';

      const animDuration = 0.8;
      const animEase = "power4.inOut";

      // Reduced motion: show immediately
      if (prefersReduced) {
        gsap.set(groupEl, { clearProps: 'all', y: 0, autoAlpha: 1 });
        return;
      }

      // If no direct children, animate the group element itself
      const directChildren = Array.from(groupEl.children).filter(el => el.nodeType === 1);
      if (!directChildren.length) {
        gsap.set(groupEl, { y: groupDistance, autoAlpha: 0 });
        ScrollTrigger.create({
          trigger: groupEl,
          start: triggerStart,
          once: true,
          onEnter: () => gsap.to(groupEl, { 
            y: 0, 
            autoAlpha: 1, 
            duration: animDuration, 
            ease: animEase,
            onComplete: () => gsap.set(groupEl, { clearProps: 'all' })
          })
        });
        return;
      }

      // Build animation slots: item or nested (deep layers allowed)
      const slots = [];
      directChildren.forEach(child => {
        const nestedGroup = child.matches('[data-reveal-group-nested]')
          ? child
          : child.querySelector(':scope [data-reveal-group-nested]');

        if (nestedGroup) {
          const includeParent = child.getAttribute('data-ignore') === 'false' || nestedGroup.getAttribute('data-ignore') === 'false';
          slots.push({ type: 'nested', parentEl: child, nestedEl: nestedGroup, includeParent });
        } else {
          slots.push({ type: 'item', el: child });
        }
      });

      // Initial hidden state
      slots.forEach(slot => {
        if (slot.type === 'item') {
          // If the element itself is a nested group, force group distance (prevents it from using its own data-distance)
          const isNestedSelf = slot.el.matches('[data-reveal-group-nested]');
          const d = isNestedSelf ? groupDistance : (slot.el.getAttribute('data-distance') || groupDistance);
          gsap.set(slot.el, { y: d, autoAlpha: 0 });
        } else {
          // Parent follows the group's distance when included, regardless of nested's data-distance
          if (slot.includeParent) gsap.set(slot.parentEl, { y: groupDistance, autoAlpha: 0 });
          // Children use nested group's own distance (fallback to group distance)
          const nestedD = slot.nestedEl.getAttribute('data-distance') || groupDistance;
          Array.from(slot.nestedEl.children).forEach(target => gsap.set(target, { y: nestedD, autoAlpha: 0 }));
        }
      });

      // Extra safety: if a nested parent is included, re-assert its distance to the group's value
      slots.forEach(slot => {
        if (slot.type === 'nested' && slot.includeParent) {
          gsap.set(slot.parentEl, { y: groupDistance }); 
        }
      });

      // Reveal sequence
      ScrollTrigger.create({
        trigger: groupEl,
        start: triggerStart,
        once: true,
        onEnter: () => {
          const tl = gsap.timeline();

          slots.forEach((slot, slotIndex) => {
            const slotTime = slotIndex * groupStaggerSec;

            if (slot.type === 'item') {
              tl.to(slot.el, { 
                y: 0, 
                autoAlpha: 1, 
                duration: animDuration, 
                ease: animEase,
                onComplete: () => gsap.set(slot.el, { clearProps: 'all' })
              }, slotTime);
            } else {
              // Optionally include the parent at the same slot time (parent uses group distance)
              if (slot.includeParent) {
                tl.to(slot.parentEl, {
                  y: 0,
                  autoAlpha: 1,
                  duration: animDuration,
                  ease: animEase,
                  onComplete: () => gsap.set(slot.parentEl, { clearProps: 'all' })
                }, slotTime);
              }
              // Nested children use nested stagger (ms → sec); fallback to group stagger
              const nestedMs = parseFloat(slot.nestedEl.getAttribute('data-stagger'));
              const nestedStaggerSec = isNaN(nestedMs) ? groupStaggerSec : nestedMs / 1000;
              Array.from(slot.nestedEl.children).forEach((nestedChild, nestedIndex) => {
                tl.to(nestedChild, { 
                  y: 0, 
                  autoAlpha: 1, 
                  duration: animDuration, 
                  ease: animEase,
                  onComplete: () => gsap.set(nestedChild, { clearProps: 'all' })
                }, slotTime + nestedIndex * nestedStaggerSec);
              });
            }
          });
        }
      });
    });

  });

  return () => ctx.revert();
}
const splitInstances = new Map();

function initSplitLines() {
  const splitLines = document.querySelectorAll('[animation="textsplit"]');

  // Handle highlighted headings
  if (document.querySelectorAll("[highligh_text]").length > 0) {
    let splitHeadingTargets = document.querySelectorAll("[highligh_text]");
    splitHeadingTargets.forEach((target) => {
      const heading = target.querySelector(".h2");
      if (!heading) return;

      const split = new SplitText(heading, {
        type: "words",
        autoSplit: false,
        wordsClass: "word"
      });
      split.split();

      splitInstances.set(heading, split);
    });
  }

  if (splitLines.length < 1) return;

  // Function to handle line splits
  function handleSplits(element) {
    if (!splitInstances.has(element)) {
      let ele = element.querySelector('*');
      if (ele?.tagName === 'BR') ele = element;
      else ele = element.querySelector('*');
      if (!ele) ele = element;

      const split = new SplitText(ele, {
        type: "lines",
        linesClass: "split-line",
        autoSplit: false,
      });

      split.lines.forEach((line, index) => {
        line.style.setProperty('--index', index);
      });

      splitInstances.set(element, split);
    }
  }

  splitLines.forEach(element => handleSplits(element));
}

// Destroy function
function destroySplitLines() {
  splitInstances.forEach((split, element) => {
    if (split.revert) {
      let translatedLines = element.getAttribute("aria-label");
      element.innerHTML = translatedLines;
      
    }
  });
}

  function setDelays(){
    const delays = [...document.querySelectorAll("[delay]")];
    delays.forEach(function (e) {
      const delay = e.getAttribute("delay");
      e.style.setProperty("--delay", delay);
    });
  }
function initSolutionsAnim(){
  let all_slides = document.querySelectorAll(".solution-slide");
  if(all_slides.length < 1){
    return;
  }
  all_slides.forEach((slide, index) => {
    let tl = gsap.timeline(
    {
      scrollTrigger: {
              scrub: true,
              trigger: slide, 
              start: "top+=90% bottom",
              end: "bottom top+=90%",
            }
    }
  );
    tl.from(slide, {
      duration: 0.2,
      ease: "none",
      scale:0.95,
      borderRadius: "20px"
    })
  })
}
function initButtonCharacterStagger() {
  const offsetIncrement = 0.01; // Transition offset increment in seconds
  const buttons = document.querySelectorAll('.button-text');

  buttons.forEach(button => {
    const text = button.textContent; // Get the button's text content
    button.innerHTML = ''; // Clear the original content

    [...text].forEach((char, index) => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.transitionDelay = `${index * offsetIncrement}s`;

      // Handle spaces explicitly
      if (char === ' ') {
        span.style.whiteSpace = 'pre'; // Preserve space width
      }

      button.appendChild(span);
    });
  });
}
function initTabSystem() {
  const wrappers = document.querySelectorAll('[data-tabs="wrapper"]');
  
  wrappers.forEach((wrapper) => {
    const contentItems = wrapper.querySelectorAll('[data-tabs="content-item"]');
    const visualItems = wrapper.querySelectorAll('[data-tabs="visual-item"]');
    
    const autoplay = wrapper.dataset.tabsAutoplay === "true";
    const autoplayDuration = parseInt(wrapper.dataset.tabsAutoplayDuration) || 5000;
    
    let activeContent = null; // keep track of active item/link
    let activeVisual = null;
    let isAnimating = false;
    let progressBarTween = null; // to stop/start the progress bar

    function startProgressBar(index) {
      if (progressBarTween) progressBarTween.kill();
      const bar = contentItems[index].querySelector('[data-tabs="item-progress"]');
      if (!bar) return;
      
      // In this function, you can basically do anything you want, that should happen as a tab is active
      // Maybe you have a circle filling, some other element growing, you name it.
      gsap.set(bar, { scaleX: 0, transformOrigin: "left center" });
      progressBarTween = gsap.to(bar, {
        scaleX: 1,
        duration: autoplayDuration / 1000,
        ease: "power1.inOut",
        onComplete: () => {
          if (!isAnimating) {
            const nextIndex = (index + 1) % contentItems.length;
            switchTab(nextIndex); // once bar is full, set next to active – this is important
          }
        },
      });
    }

    function switchTab(index) {
      if (isAnimating || contentItems[index] === activeContent) return;
      
      isAnimating = true;
      if (progressBarTween) progressBarTween.kill(); // Stop any running progress bar here
      
      const outgoingContent = activeContent;
      const outgoingVisual = activeVisual;
      const outgoingBar = outgoingContent?.querySelector('[data-tabs="item-progress"]');
      
      const incomingContent = contentItems[index];
      const incomingVisual = visualItems[index];
      const incomingBar = incomingContent.querySelector('[data-tabs="item-progress"]');
      
      outgoingContent?.classList.remove("active");
      outgoingVisual?.classList.remove("active");
      incomingContent.classList.add("active");
      incomingVisual.classList.add("active");
      
      const tl = gsap.timeline({
        defaults: { duration: 0.65, ease: "power3" },
        onComplete: () => {
          activeContent = incomingContent;
          activeVisual = incomingVisual;
          isAnimating = false;
          if (autoplay) startProgressBar(index); // Start autoplay bar here
        },
      });
      
      // Wrap 'outgoing' in a check to prevent warnings on first run of the function
      // Of course, during first run (on page load), there's no 'outgoing' tab yet!
      if (outgoingContent) {
        outgoingContent.classList.remove("active");
        outgoingVisual?.classList.remove("active");
        tl.set(outgoingBar, { transformOrigin: "right center" })
          .to(outgoingBar, { scaleX: 0, duration: 0.3 }, 0)
          .to(outgoingVisual, { autoAlpha: 0, xPercent: 3 }, 0)
          .to(outgoingContent.querySelector('[data-tabs="item-details"]'), { height: 0 }, 0);
      }

      incomingContent.classList.add("active");
      incomingVisual.classList.add("active");
      tl.fromTo(incomingVisual, { autoAlpha: 0, xPercent: 3 }, { autoAlpha: 1, xPercent: 0 }, 0.3)
        .fromTo( incomingContent.querySelector('[data-tabs="item-details"]'),{ height: 0 },{ height: "auto" },0)
        .set(incomingBar, { scaleX: 0, transformOrigin: "left center" }, 0);
    }

    // on page load, set first to active
    // idea: you could wrap this in a scrollTrigger
    // so it will only start once a user reaches this section
    switchTab(0);
    
    // switch tabs on click
    contentItems.forEach((item, i) =>
      item.addEventListener("click", () => {
        if (item === activeContent) return; // ignore click if current one is already active
        switchTab(i);
      })
    );
    
  });
}
function leaderTitlehide(){
  let main_section = document.querySelector(".our-leaders");
  if (!main_section) {
    return;
  }
  let title = main_section.querySelector(".our-leader-header .h2");
      let tl = gsap.timeline({
            scrollTrigger: {
              scrub: true,
              trigger: main_section, 
              start: "top top",
              end: "+=20%",
            }
          })
          tl.to(title,{
            opacity: 0
          })
}
function departmentMenuToggle(){
  let departments = document.querySelector(".departments");
  if (!departments) {
    return;
  }
  let tabbtns = departments.querySelectorAll(".departments-tabs .tab-btn");
  let tabContents = departments.querySelectorAll(".departments-content");
  let minHeight = 0;
  tabContents.forEach(content => {
    minHeight = Math.max(minHeight, content.offsetHeight);
  });
  departments.style.setProperty("--height", minHeight + "px");
  tabbtns.forEach((btn,index) => { 
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      tabbtns.forEach(btn => btn.classList.remove("active"));
      tabContents.forEach(content => content.classList.remove("active"));
      btn.classList.add("active");
      tabContents[index].classList.add("active");
  });
})
}
function historySlider(){
    const timelineSections = document.querySelectorAll(".timeline-section-2");
if(!timelineSections.length){
  return;
}
  timelineSections.forEach(section => {
    const items = section.querySelectorAll(".timeline-cms-item");
    const tabs = section.querySelectorAll(".timeline-tab-2");
    const prevBtn = section.querySelector(".timeline-prev-btn");
    const nextBtn = section.querySelector(".timeline-next-btn");
    let currentIndex = 0;
    let progressTween;

    // Setup progress bars
    tabs.forEach(tab => {
      if (!tab.querySelector(".progress-bar")) {
        const bar = document.createElement("span");
        bar.classList.add("progress-bar");
        tab.appendChild(bar);
      }
    });

    // Function to show item
    function showItem(index) {
      const current = section.querySelector(".timeline-cms-item:not([style*='display: none'])");
      const target = items[index];

      if (current && target && current !== target) {
        gsap.to(current, {
          opacity: 0,
          y: -20,
          duration: 0.4,
          onComplete: () => {
            current.style.display = "none";
            target.style.display = "block";
            gsap.fromTo(target, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.4 });
          }
        });
      }

      // Update active tabs
      tabs.forEach((t, i) => t.classList.toggle("active", i === index));

      startProgress(index);
    }

    // Progress animation
    function startProgress(index) {
      if (progressTween) progressTween.kill();
      tabs.forEach(tab => tab.querySelector(".progress-bar").style.width = "0%");
      const bar = tabs[index].querySelector(".progress-bar");
      progressTween = gsap.to(bar, {
        width: "100%",
        duration: 5,
        ease: "linear",
        onComplete: () => {
          currentIndex = (index + 1) % items.length;
          showItem(currentIndex);
        }
      });
    }

    // Tab click
    tabs.forEach((tab, i) => tab.addEventListener("click", () => {
      currentIndex = i;
      showItem(currentIndex);
    }));

    // Prev/Next buttons
    if (prevBtn) prevBtn.addEventListener("click", () => {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      showItem(currentIndex);
    });

    if (nextBtn) nextBtn.addEventListener("click", () => {
      currentIndex = (currentIndex + 1) % items.length;
      showItem(currentIndex);
    });

    // Initial setup
    items.forEach((item, i) => item.style.display = i === 0 ? "block" : "none");
    tabs[0].classList.add("active");
    startProgress(0);
  });


}
function visionMissionAnimation(){
  let section = document.querySelector(".vision-mission-w");
  if (!section) {
    return;
  }
  if(isTablet()){

    let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=40%",
      scrub: true,
    }
  });
  let tl2= gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top+=30%",
      end: "+=150%",
      scrub: true,
    }
  });
  tl.to(section.querySelector(".svg.svg1.circle-svg"),{
    x: "27%",
    y:"-50%"
  },"-=")
    tl.to(section.querySelector(".svg.svg2.circle-svg"),{
    y: "60%",
    x:"0%"
  },"-=")
   tl.to(section.querySelector(".svg.svg3.circle-svg"),{
    x: "-27%",
    y:"75%"
    
  },"-=")
  tl.to(section.querySelectorAll(".svg-main"),{
    opacity: 0,
  },"-=")
   tl.to(section.querySelectorAll(".svg.svg-main.img-absolute"),{
    opacity: 0,
    duration:0.3
  },"-=")
  tl.to(section.querySelectorAll(".svg-second"),{
    opacity: 1,
  },"-=")
if(isMobile())
{
  tl.to(section.querySelectorAll(".mission-vision-svg-wrap"),{
    scale:0.8,
  },"-=")

    tl2.to(section.querySelectorAll(".div-block-16"),{
      y:"-100%",
  },"-=1")
  
}

    return;
  }
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=40%",
      scrub: true,
    }
  });
  let tl2= gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top+=30%",
      end: "+=150%",
      scrub: true,
    }
  });
  tl.to(section.querySelector(".svg.svg1.circle-svg"),{
    x: "-40%",
    y:"-23.5%"
  },"-=")
    tl.to(section.querySelector(".svg.svg2.circle-svg"),{
    y: "23.5%",
  },"-=")
   tl.to(section.querySelector(".svg.svg3.circle-svg"),{
    x: "40%",
    y:"-23.5%"
    
  },"-=")
  tl.to(section.querySelectorAll(".svg-main"),{
    opacity: 0,
  },"-=")
   tl.to(section.querySelectorAll(".svg.svg-main.img-absolute"),{
    opacity: 0,
    duration:0.3
  },"-=")
  tl.to(section.querySelectorAll(".svg-second"),{
    opacity: 1,
  },"-=")
if(isMobile())
{
  tl.to(section.querySelectorAll(".mission-vision-svg-wrap"),{
    scale:0.8,
  },"-=")

    tl2.to(section.querySelectorAll(".div-block-16"),{
      y:"-100%",
  },"-=1")
  
}
}
// function valuesAnimation() {
function valuesAnimation() {
  const wrapper = document.querySelector(".value-slides-wrapper");
  if (!wrapper) return;

  const slides = gsap.utils.toArray(".value-slide");
  const totalSlides = slides.length;
  const rotationPerSlide = -90; // degrees per slide
  const container = document.querySelector(".value-slides-i");

  // Initial setup
  gsap.set(container, { rotation: 0 });
  slides.forEach((s, i) => s.classList.toggle("active", i === 0));

  // Create a timeline that smoothly rotates with scroll
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: wrapper,
      start: "top top",
      end: () => `+=${(totalSlides - 1) * window.innerHeight}`,
      scrub: 1,
      pin: false,
      onUpdate: (self) => {
        // Calculate active slide based on progress
        const index = Math.round(self.progress * (totalSlides - 1));
        slides.forEach((s, i) => s.classList.toggle("active", i === index));
      }
    }
  });

  // Rotate container smoothly with scroll progress
  tl.to(container, {
    rotation: rotationPerSlide * (totalSlides - 1),
    ease: "none" // linear link to scroll
  });
}

//   let main_section = document.querySelector(".our-values");
//   if (!main_section) {
//     return;
//   }

//   let all_slides = document.querySelectorAll(".value-slide");
//   let totalSlides = all_slides.length;
//   totalSlides = totalSlides -1;
//   const rotationPerSlide = 90; // Degrees to rotate per slide
//   let lastProgress = 0;

// let tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".value-slides-wrapper",
//     start: "top top", 
//     end: "bottom bottom",
//     scrub: true,
//     onUpdate: (self) => {
//       // Calculate active slide index based on progress divided by number of slides
//       const progress = self.progress;
//       const slideProgress = progress / (1 / totalSlides);
//       const slideIndex = Math.floor(slideProgress);
      
//       all_slides.forEach((slide, index) => {
//         console.log(index, slideIndex);
//         if(index === slideIndex) {
//           slide.classList.add("active");
//         } else {
//           slide.classList.remove("active");
//         }
//       });
//     }
//   }
// });

//   tl.to(".value-slides-i", {
//     rotation: -90 * totalSlides,
//     duration: 0.5,
//     ease: "power2.out"
//   });
// }

function initCenteredScalingNavigationBar() {
  const navigationInnerItems = document.querySelectorAll(".nav-list-item")
  
  navigationInnerItems.forEach((item, index)=> {
      item.style.transitionDelay = `${index * 0.05}s`;
  });
  
  let nav_parent_lnk = [...document.querySelectorAll(".nav-list-item .nav-link-2")];

    nav_parent_lnk.forEach(nav_link => {
      let next_element = nav_link.nextElementSibling;
      if(!next_element) return;
      next_element.style.setProperty("--data-height", next_element.scrollHeight + "px");
      next_element.style.setProperty("height", "0px");
      nav_link.addEventListener("click", function () {
        nav_parent_lnk.forEach(element => {
          if (element !== nav_link) {
            element.classList.remove("active");
          }
        });

        nav_link.classList.toggle("active");
      });

    });
  // Toggle Navigation
  document.querySelectorAll('[data-navigation-toggle="toggle"]').forEach(toggleBtn => {
    toggleBtn.addEventListener('click', () => {
      const navStatusEl = document.querySelector('[data-navigation-status]');
      if (!navStatusEl) return;
      if (navStatusEl.getAttribute('data-navigation-status') === 'not-active') {
        navStatusEl.setAttribute('data-navigation-status', 'active');
        window.locomotiveScroll.stop();
      } else {
        navStatusEl.setAttribute('data-navigation-status', 'not-active');
        window.locomotiveScroll.start();
      }
    });
  });

  document.querySelectorAll('[data-navigation-toggle="close"]').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const navStatusEl = document.querySelector('[data-navigation-status]');
      if (!navStatusEl) return;
      navStatusEl.setAttribute('data-navigation-status', 'not-active');
      // If you use Lenis you can 'start' Lenis here: Example Lenis.start();
      window.locomotiveScroll.start();
    });
  });

  // Key ESC - Close Navigation
  document.addEventListener('keydown', e => {
    if (e.keyCode === 27) {
      const navStatusEl = document.querySelector('[data-navigation-status]');
      if (!navStatusEl) return;
      if (navStatusEl.getAttribute('data-navigation-status') === 'active') {
        navStatusEl.setAttribute('data-navigation-status', 'not-active');
       // If you use Lenis you can 'start' Lenis here: Example Lenis.start();
       window.locomotiveScroll.start();
      }
    }
  });
}
function commonFunctions(){
    if(document.querySelector(".view-all-faqs")){
      document.querySelector(".view-all-faqs").addEventListener("click", function(){
        document.querySelector(".faqs-container.hide-sm").classList.remove("hide-sm");
        document.querySelector(".view-all-faqs").classList.add("hide-sm");
            })
    }
     document.querySelectorAll("[href='#submit']").forEach((btn)=>{
  btn.addEventListener("click",(e)=>{
    e.preventDefault();
    let nextButton = btn.nextElementSibling;
    if(nextButton){
      nextButton.removeAttribute("disabled");
      nextButton.click();
    }
  })
 })
 if(isMobile() || isTablet()){
  document.querySelectorAll('table').forEach(el => {
    el.setAttribute('data-lenis-prevent', '');
  });
 }
 const collectionItemDownloads = document.querySelectorAll(".collection-item-download");
 collectionItemDownloads.forEach((item)=>{
  item.addEventListener("click",(e)=>{
  //  item.querySelector("a").setAttribute("download", "download");
  //  item.querySelector("a").setAttribute("target", "_blank");
  })
 })
}
function heightObserver(){
  if(window.innerWidth < 768){
    return;
  }
const resizeObserver = new ResizeObserver(() => {
  window.locomotiveScroll.lenisInstance.resize()
});

resizeObserver.observe(document.querySelector('main'));
}
function getStatesByCountryName(data, countryName) {
  data = data[0] || [];
  const countryCode = Object.keys(data.country)
    .find(code => data.country[code].toLowerCase() === countryName.toLowerCase());
  if (!countryCode) {
    return [];
  }
  return data.states[countryCode] || [];
}
function makeStaterequireIndia() {
  if (document.querySelectorAll("select[name='Select-Country']").length === 0) {
    return;
  }

  // Build the <select> for Indian states
  const stateSelectBox = document.createElement("select");
  stateSelectBox.setAttribute("name", "State-Select");
  stateSelectBox.classList.add("state-select-box");
  stateSelectBox.classList.add("select-field");
  stateSelectBox.classList.add("w-select");

  // Create default option
  const defaultOpt = document.createElement("option");
  defaultOpt.value = "";
  defaultOpt.textContent = "State";
  defaultOpt.selected = true;
  stateSelectBox.setAttribute("required", false);
  stateSelectBox.appendChild(defaultOpt);

  // Insert select after each State input and hide it initially
  document.querySelectorAll("[name='Select-Country']").forEach(stateInput => {
    stateInput.parentNode.insertBefore(stateSelectBox.cloneNode(true), stateInput.nextSibling);
  });

  // Load country-states.json once
  fetch("https://atlantiser-webflow.myshopify.com/cdn/shop/t/1/assets/country-states.json")
    .then(res => res.json())
    .then(data => {
      document.querySelectorAll("select[name='Select-Country']").forEach(countrySelect => {
        countrySelect.addEventListener("change", e => {
          const chosenCountry = e.target.value;
          const isIndia = chosenCountry === "India";

            const states = getStatesByCountryName(data, chosenCountry);
            document.querySelectorAll("[name='State-Select']").forEach(selectEl => {
              selectEl.innerHTML = ""; 
              if(isIndia){
                defaultOpt.textContent = "State*";
              }else{
                defaultOpt.textContent = "State";
              }
              selectEl.appendChild(defaultOpt.cloneNode(true));
              states.forEach(st => {
                const opt = document.createElement("option");
                opt.value = st.name;
                opt.textContent = st.name;
                selectEl.appendChild(opt);
              });
            });

          // Toggle visibility & required
          document.querySelectorAll("[name='State-Select']").forEach(el => {
            const isSelect = el.tagName.toLowerCase() === "select";
            el.style.display = isSelect ? "block" : "none";
            el.style.display = !isSelect ? "none" : "block";
            if (isIndia) {
              if (isSelect) el.setAttribute("required", true);
              else el.removeAttribute("required");
            } else {
              if (isSelect) el.removeAttribute("required");
              else el.setAttribute("required", true);
            }
          });
        });

        // Trigger initial state
        countrySelect.dispatchEvent(new Event("change"));
      });
    })
    .catch(err => console.error("Failed to load country-states.json", err));

}
function getShareData(){
  const COOKIE_NAME = 'vikramShareData';
  const COOKIE_MAX_AGE = 2 * 60 * 60; // 2 hours in seconds

  // Helper: get cookie value
  function getCookie(name) {
    const v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return v ? v.pop() : null;
  }

  // Helper: set cookie with max-age
  function setCookie(name, value, maxAge) {
    document.cookie = `${name}=${encodeURIComponent(value)};max-age=${maxAge};path=/`;
  }

  // If cached data exists, use it
  const cached = getCookie(COOKIE_NAME);
  if (cached) {
    try {
      const data = JSON.parse(cached);
      applyShareData(data);
      return;
    } catch (e) {
    }
  }

  // Fetch fresh data
  fetch("https://www.moneycontrol.com/india/stockpricequote/pharmaceuticals/vikramthermoindia/VTI03")
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const price = doc.getElementById("bsecp")?.textContent.trim() || '';
      let BSEChange = doc.querySelector(".pricupdn")?.textContent.trim() || '';
      const bseasondate = doc.querySelector(".bseasondate")?.textContent.trim() || '';
      
      let up = true;
      if(doc.querySelector(".pricupdn .reddownarow")){
        up = false;
      }
      const payload = { price, BSEChange, bseasondate,up };
      setCookie(COOKIE_NAME, JSON.stringify(payload), COOKIE_MAX_AGE);
      applyShareData(payload);
    })
    .catch(err => console.error("Share data fetch failed", err));
}
function loaderAnimation(){
  const main_loader = document.querySelector(".main-loader");
  if(!main_loader){
    return;
  }
  const svg = main_loader.querySelector("svg g path");
  let bg = main_loader.querySelector(".loader-bg");
  setTimeout(() => {
    document.body.classList.add("is-loaded");
  }, 400);
  let tl = gsap.timeline();
  tl.to(bg,{
    duration: 0.7,
    opacity: "0",
    ease: "power3.inOut"
  })
  tl.to(main_loader.querySelector("svg g"),{
    duration: 0.7,
    transform: "rotate(25deg)",
    ease: "power3.inOut"
  }, "-=")
  tl.to(svg,{
    duration: 1.5,
    transform: "scale(300) translate(30px,1%)",
    ease: "power3.inOut",
    onComplete: ()=>{
      main_loader.remove();
      document.body.classList.add("loaded-once");
    }
  }, "-=");
}
// New helper: apply share data to DOM elements
function applyShareData({ price, BSEChange, bseasondate,up }) {

  document.querySelectorAll('[data-share="price"]').forEach(el => el.textContent = price);
  document.querySelectorAll('[data-share="change"]').forEach(el => el.textContent = BSEChange);
  document.querySelectorAll('[data-share="date"]').forEach(el => el.textContent = bseasondate);
  if(up){
    document.querySelectorAll('[changedownup]').forEach(el => el.classList.remove("down"));
    document.querySelectorAll('[changedownup]').forEach(el => el.classList.add("up"));
  }
  else{
    document.querySelectorAll('[changedownup]').forEach(el => el.classList.remove("up"));
    document.querySelectorAll('[changedownup]').forEach(el => el.classList.add("down"));
  }
}
function languageTranslation(){
   const gtScript = document.createElement('script');
  gtScript.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  document.head.appendChild(gtScript);

  const style = document.createElement('style');
  style.innerHTML = `
    body { top: 0px !important; position: static !important; }
    .goog-te-banner-frame, .skiptranslate,
    #goog-gt-tt, .goog-te-balloon-frame,
    .goog-text-highlight {
      display: none !important;
      background: none !important;
      box-shadow: none !important;
    }
  `;
  document.head.appendChild(style);

  window.googleTranslateElementInit = function () {
    new google.translate.TranslateElement({
      pageLanguage: 'en',
      layout: google.translate.TranslateElement.FloatPosition.TOP_LEFT
    }, 'google_translate_element');
  };

  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split('=');
      if (key === name) return decodeURIComponent(value);
    }
    return null;
  }

  const languageMap = new Map([
    ["af","Afrikaans"], ["sq","Albanian"], ["ar","Arabic"], ["hy","Armenian"],
    ["az","Azerbaijani"], ["eu","Basque"], ["be","Belarusian"], ["bg","Bulgarian"],
    ["ca","Catalan"], ["zh-CN","ChineseSimplified"], ["zh-TW","ChineseTraditional"], 
    ["hr","Croatian"], ["cs","Czech"], ["da","Danish"], ["nl","Dutch"], ["de","German"],
    ["en","English"], ["et","Estonian"], ["tl","Filipino"], ["fi","Finnish"], 
    ["fr","French"], ["gl","Galician"], ["ka","Georgian"], ["el","Greek"], 
    ["ht","Haitian"], ["iw","Hebrew"], ["hi","Hindi"], ["hu","Hungarian"], 
    ["is","Icelandic"], ["id","Indonesian"], ["ga","Irish"], ["it","Italian"], 
    ["ja","Japanese"], ["ko","Korean"], ["lv","Latvian"], ["lt","Lithuanian"], 
    ["mk","Macedonian"], ["ms","Malay"], ["mt","Maltese"], ["no","Norwegian"], 
    ["fa","Persian"], ["pl","Polish"], ["pt","Portuguese"], ["ro","Romanian"], 
    ["ru","Russian"], ["sr","Serbian"], ["sk","Slovak"], ["sl","Slovenian"], 
    ["es","Spanish"], ["sw","Swahili"], ["sv","Swedish"], ["th","Thai"], 
    ["tr","Turkish"], ["uk","Ukrainian"], ["ur","Urdu"], ["vi","Vietnamese"], 
    ["cy","Welsh"], ["yi","Yiddish"]
  ]);

  let currentLang = getCookie("googtrans")?.split("/").pop() || "en";

  const readableLang = languageMap.get(currentLang);
    const langClass = `.languagespecific.${readableLang?.toLowerCase()}specific`;
    const fallbackClass = `.languagespecific.englishspecific`;

    if (document.querySelector(langClass)) {
      document.querySelectorAll(langClass).forEach(el => el.style.display = 'block');
    } else {
      document.querySelectorAll(fallbackClass).forEach(el => el.style.display = 'block');
    }

    document.querySelectorAll('[data-ms-code-lang-select]').forEach(el => {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        const selectedLang = this.getAttribute('data-ms-code-lang');
        if (selectedLang === 'en') {
          document.cookie = "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          document.cookie = "googtrans=;domain=.webflow.io;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          window.location.hash = "";
          setTimeout(() => location.reload(true), 100);
        } else {
          const combo = document.querySelector('.goog-te-combo');
          if (combo) combo.value = selectedLang;
          window.location.hash = "#googtrans(en|" + selectedLang + ")";
          location.reload();
        }
        
      });
    });
}
function studentForm(){
  let form_popup = document.querySelector(".student-form");
  if(!form_popup){
    return;
  }
  let opener = document.querySelector(".are-you-sudent-i a");
  opener.addEventListener("click", function(e){
    e.preventDefault();
    form_popup.classList.add("show");
    window.locomotiveScroll.stop();
  })
  let closer = document.querySelector(".student-form .popup-overlay");
  closer.addEventListener("click", function(e){
    e.preventDefault();
    form_popup.classList.remove("show");
    window.locomotiveScroll.start();
  })
  let closeBtn = document.querySelector(".student-form .close-popup");
  closeBtn.addEventListener("click", function(e){
    e.preventDefault();
    form_popup.classList.remove("show");
    window.locomotiveScroll.start();
  })
}
function checkGeoLocation(){
  window.isIndia = false;
  if(window.isIndia){
     const stateField = document.querySelector("#State");
                if (stateField) {
                    stateField.setAttribute("required", "required");
                    stateField.placeholder = "State *";
                }
    return;
  }
   fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(data => {
            if (data.country_code === "IN") {
                window.isIndia = true;
                const stateField = document.querySelector("#State");
                if (stateField) {
                    stateField.setAttribute("required", "required");
                    stateField.placeholder = "State *";
                }
            }
        })
        .catch(err => console.error("Geo lookup failed", err));
}
function initFilterShowMore() {

}
function openPopupforDownload(){
  const formWrapper = document.querySelector('.download-form');
  if (!formWrapper) return;

  let lastclickedlink = null;
  const form = formWrapper.querySelector('form');
  const cards = document.querySelectorAll('.resouces-cards a');

  const successMsg = formWrapper.querySelector('.w-form-done');
  const failMsg = formWrapper.querySelector('.w-form-fail');

  function resetFormState() {
    form.style.display = 'block';
    if(successMsg) successMsg.style.display = 'none';
    if(failMsg) failMsg.style.display = 'none';
    form.reset();
  }

  document.querySelector(".download-form .close-popup").addEventListener("click", function(e){
    e.preventDefault();
    formWrapper.classList.remove("show");
    window.locomotiveScroll.start();
    resetFormState();
  });
  let fileUrl = null;
  cards.forEach(card => {
    card.addEventListener("click", function(e){
      e.preventDefault();
      
      resetFormState(); 
      fileUrl = card.getAttribute("href");
      lastclickedlink = card.getAttribute("resource_slug");
      document.querySelector("#resource_slug").value = lastclickedlink;

      formWrapper.classList.add("show");
      window.locomotiveScroll.stop();
    });
  });

  form.addEventListener('submit', function () {

    const successCheck = setInterval(() => {
      if (successMsg && getComputedStyle(successMsg).display !== 'none') {
        // window.open(fileUrl, '_blank');
        clearInterval(successCheck);

        setTimeout(() => {
          formWrapper.classList.remove("show");
          window.locomotiveScroll.start();
          
          resetFormState();
        }, 2000);

      }
    }, 100);

  });
}


function profilePopups() {
  const profiles = document.querySelectorAll("[data-wf--card--card-style='profile-card']");
  if (!profiles.length) return;

  profiles.forEach(profile => {
    profile.addEventListener("click", function (e) {
      e.preventDefault();
      const popup = profile.querySelector(".profile-popup");
      if (!popup) return;

      // Pause locomotive scroll while popup is open
      if (window.locomotiveScroll) window.locomotiveScroll.stop();

      const clone = popup.cloneNode(true);
      const wrapper = document.querySelector(".profile-popup-wrapper");
      if (!wrapper) return;

      wrapper.appendChild(clone);
      setTimeout(() => {
        clone.classList.add("show");
      }, 10);

      // Bind close listener only after clone is in DOM
      const closeBtn = clone.querySelector(".close-popup");
      if (closeBtn) {
        closeBtn.addEventListener("click", function (evt) {
          evt.preventDefault();
          clone.classList.remove("show");
          clone.addEventListener("transitionend", () => {
            clone.remove();
            // Resume locomotive scroll when popup is closed
            if (window.locomotiveScroll) window.locomotiveScroll.start();
          }, { once: true });
        });
      }

       let closer = clone.querySelector(".popup-overlay");
  closer.addEventListener("click", function(e){
    e.preventDefault();
    clone.classList.remove("show");
    clone.addEventListener("transitionend", () => {
      clone.remove();
      if (window.locomotiveScroll) window.locomotiveScroll.start();
    }, { once: true });
  })

    });
     
  });
}
function numberAnimation(){
  const numberElements = document.querySelectorAll('.number');
  numberElements.forEach(element => {
    // Create a ScrollTrigger for each element
    let textContent = element.textContent.trim();
    element.textContent = "";
    ScrollTrigger.create({
      trigger: element,
      start: 'top 80%', // when top of element hits 80% of viewport
      once: true,       // animate only once
      onEnter: () => {
        const rawText = textContent;
        const hasPlus = rawText.endsWith('+');
        const targetNumber = parseInt(rawText.replace(/[+,]/g, ''));
        let currentNumber = 0;
        const duration = 2000; // 2 seconds
        const interval = 50; // Update every 50ms
        const steps = duration / interval;
        const stepValue = targetNumber / steps;

        const animation = setInterval(() => {
          currentNumber += stepValue;
          let display = Math.round(currentNumber).toLocaleString();
          if (hasPlus) display += '+';
          element.textContent = display;
          if (currentNumber >= targetNumber) {
            clearInterval(animation);
            let final = targetNumber.toLocaleString();
            if (hasPlus) final += '+';
            element.textContent = final;
          }
        }, interval);
      }
    });
  });
}
function selectProduct(){
  const product_checkboxes = document.querySelectorAll('[data-name="Product"]');
  const selectInput = document.querySelector('#Product-name');
  let selectedProducts = []; // collect multiple selections

  product_checkboxes.forEach(checkbox => {
    checkbox.addEventListener("click", function(){
      if(checkbox.checked){
        const label = checkbox.nextElementSibling.textContent.trim();
        if(!selectedProducts.includes(label)) selectedProducts.push(label);
      } else {
        const label = checkbox.nextElementSibling.textContent.trim();
        selectedProducts = selectedProducts.filter(p => p !== label);
      }
      selectInput.value = selectedProducts.join(', ');
    });
  });
}
function downloadResource(){
  const form = document.getElementById('wf-form-Download-form');
  if(!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault(); // STOP default form submission
    const formData = new FormData(form);
	
    fetch('https://webflow.testro.in/download-handler.php', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {

    })
    .catch(err => console.error('Request failed:', err));
  });
}
document.fonts.ready.then(() => {
  initSplitLines();
  setTimeout(() => {
      initHighlightText();
    }, 500);
});

document.addEventListener('DOMContentLoaded', () => {
      if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
if(document.querySelector(".google-icons")){
  let currentLang = document.documentElement.getAttribute("lang");
  document.querySelector(".google-icons").textContent = currentLang;
  setTimeout(() => {
    currentLang = document.documentElement.getAttribute("lang");
  document.querySelector(".google-icons").textContent = currentLang;
  }, 800);
}
 window.scrollTo(0,0)
  let dvh = window.innerHeight;
  document.querySelector("body").style.setProperty("--_spaces---h-vh-100", dvh + "px");
  let vw = window.innerWidth * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
let headerHeight = document.querySelector(".navbar-wrapper").offsetHeight;
let announcement_height = document.querySelector(".announcement-bar").offsetHeight;
document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
document.documentElement.style.setProperty('--announcement-height', `${announcement_height}px`);
  setTimeout(() => {
    selectProduct();
    initGalleryOverlayTransitionFlip();
  initSwiper();
  initProgressNavigation();
  initAccordionCSS();
  footerToggles();
  headerHideShow();
  initrotateonScroll();
  scrollMore();
    
  megamenuSubitems();
  initLenis();
  initContentRevealScroll();
  
  initButtonCharacterStagger();
  setDelays();
  initTabSystem();
  departmentMenuToggle();
  leaderTitlehide();
  visionMissionAnimation();
  valuesAnimation();
  initCenteredScalingNavigationBar();
  commonFunctions();
  getShareData();
  languageTranslation();
  studentForm() 
  // checkGeoLocation();
  initFilterShowMore();
  openPopupforDownload();
  profilePopups();
  makeStaterequireIndia();
  // initSolutionsAnim();
  loaderAnimation();
  heightObserver();
  // numberAnimation();
  selectFilter();
  uploadFilesetup();
  downloadResource();
  }, 500);
  
});


function updateActiveLink() {
    const currentPath = window.location.pathname; 
    const navLinks = document.querySelectorAll('a');

    navLinks.forEach(link => {
        link.classList.remove('w--current');
        if (link.getAttribute('href') === currentPath) {
            link.classList.add('w--current');
        }
    });
}
function selectFilter(){
  if(! document.querySelector(".download-filter-items")) return;
 let search_box = document.querySelector(".investor-search");
 let search_select = document.querySelector(".select-filter_2");
 let categories = document.querySelectorAll(".download-filter-items .filter-btn input");
 categories.forEach(category => {
  category.addEventListener("change", (e) => {
    let selectedValue = e.target.getAttribute("fs-list-value");
      document.querySelector(".selected-cat").textContent = selectedValue;
      const select = document.querySelector('select#select_option2');

if (select) {
  select.value = select.options[0].value;

  select.dispatchEvent(new Event('input', { bubbles: true }));
  select.dispatchEvent(new Event('change', { bubbles: true }));
}
  })
 })
 search_select.addEventListener("change", (e) => {
  let selectedValue = e.target.value;  
  search_box.value = selectedValue;
  search_box.dispatchEvent(new Event('input', { bubbles: true }));
 })
}
function uploadFilesetup(){
  document.querySelectorAll('input[type="file"][data-target]')
    .forEach(input => {
      input.addEventListener("change", async function () {
        if (!this.files.length) return;

        const file = this.files[0];
        const targetSelector = this.dataset.target;
        const targetInput = document.querySelector(targetSelector);

        const formData = new FormData();
        formData.append("file", file);

        this.disabled = true;

        try {
          const response = await fetch(
            "https://webflow.testro.in/uploads.php",
            {
              method: "POST",
              body: formData
            }
          );

          const data = await response.json();

          if (!response.ok || data.status !== "success") {
            throw new Error(data.message || "Upload failed");
          }

          targetInput.value = data.file_url;

        } catch (err) {
          alert("Upload failed. Please try again.");
          console.error(err);
          this.value = "";
          targetInput.value = "";
        } finally {
          this.disabled = false;
        }
      });

    });

}
function addAllOption(){
  if(!document.querySelector(".selected-filter-year .select-filter_2")) return;
  document.querySelector(".selected-filter-year .select-filter_2").addEventListener("change", function(event) {
  if(event.target.value == "All"){
      setTimeout(() => {
        document.querySelectorAll('[fs-list-element="clear"]').forEach(el => el.click());
      }, 200);
  }
});
}
function select_option2(){
  if(!document.querySelector("#select_option2")) return;
  const exclude = ["Brief profile of Board of Directors","Code of conduct for Board of Directors & Senior Management Personnel","Composition of various committees of Board of Directors","Demerger","Details of KMP for Determining Materiality of Events","Familiarization program for Independent Directors","Integrated Filing (Financials)","Other Disclosures","Policies","Terms and conditions of appointment of Independent Directors","Vikram_Thermo Signed altered MOA"];
  document.querySelector("#select_option2").addEventListener("change", function(event) {
  if(exclude.includes(event.target.value)){
     document.body.classList.add("hide-year")
     document.querySelector(".selected-filter-year .select-filter_2").value = null;
     document.querySelector(".selected-filter-year .select-filter_2").dispatchEvent(new Event('change', { bubbles: true }));
  }
  else{
    document.body.classList.remove("hide-year")
  }
});
}
function initTurnstile(){
  document.querySelectorAll("form[data-turnstile-sitekey]").forEach(form => {
  const container = form.querySelector(".cf-turnstile");

  if (!container) return;

  // Remove any previous widget
  container.innerHTML = "";

  turnstile.render(container, {
    sitekey: form.dataset.turnstileSitekey
  });
});
}
function initPage(){
  selectFilter();
  getProductvideo();
    initGalleryOverlayTransitionFlip();
  initSwiper();
  initProgressNavigation();
  initAccordionCSS();
  initrotateonScroll();
  selectProduct();
  scrollMore();
    setTimeout(() => {
      initHighlightText();
    }, 500);
  initContentRevealScroll();
  initSplitLines();
  initButtonCharacterStagger();
  setDelays();
  initTabSystem();
  departmentMenuToggle();
  leaderTitlehide();
  visionMissionAnimation();
  valuesAnimation();
  commonFunctions();
  studentForm();
  getShareData();
  initFilterShowMore();
  openPopupforDownload();
  profilePopups();
  makeStaterequireIndia();
  heightObserver();
  uploadFilesetup();
  downloadResource();
  // numberAnimation();
  // checkGeoLocation();
   
}
const swup = new Swup({
  containers: ["main"],
  ignoreVisit: (url, { el } = {}) => el?.closest('[href="#"], [href="#reset_form"],[href="#submit"],[data-no-swup]'),
  linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup]),a[data-ms-code-lang-select]',
  animateHistoryBrowsing: true,
  cache: true,

  plugins: [new SwupPreloadPlugin()]
});

  swup.hooks.on("page:view", () => {
    window.scrollTo(0, 0);
    initPage();
    updateActiveLink();
  });
  function beforePageChange(){
    document.body.classList.remove("is-loaded");
    if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
        }
        document.querySelector("[data-navigation-status]").setAttribute("data-navigation-status","not-active")
    let footer_labels = [...document.querySelectorAll(".footer-l-title")];
    
    footer_labels.forEach(footer_label => {
      footer_label.classList.remove("active")
    });

        
    
  }
  swup.hooks.replace('animation:out:await', async () => {
    beforePageChange();
    await new Promise(resolve => setTimeout(resolve, 200));
    return true;

  });

  swup.hooks.replace('animation:in:await', async () => {
    window.scrollTo(0, 0);
    getProductData();
    initLenis()
    addAllOption();
    select_option2();
        // FsAttributes.destroy()
        // FsAttributes.cmsfilter.init();
        if (window.FinsweetAttributes) {
          window.FinsweetAttributes.destroy();
          window.FinsweetAttributes.modules.list.restart()
        }
        Webflow.ready();
    await new Promise(resolve => setTimeout(resolve, 200));
    initTurnstile();
    document.body.classList.add("is-loaded");
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.load();
      video.play();
    });
    return true;
  });

  function siteBy() {
  if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    var args = ['%cMade with ♥ by Atlantiser®', 'color: #fff; background:rgb(0, 0, 0); padding:10px 10px;'];
    window.console.log.apply(console, args);
  } else if (window.console) {
    window.console.log('Made with love ♥ Atlantiser®');
  }
}

siteBy();

document.addEventListener("langChange", (event) => {
  document.querySelector(".google-icons").textContent = event.detail;
  if(event.detail !== "en"){
   destroySplitLines();
   
  }
});

const htmlEl = document.documentElement; 
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === "attributes" && mutation.attributeName === "lang") {
      const newLang = htmlEl.getAttribute("lang");
      document.dispatchEvent(new CustomEvent("langChange", { detail: newLang }));
    }
  });
});

// Start observing
observer.observe(htmlEl, { attributes: true });


function initCountdown(){
  if(!document.querySelector(".coming--sooon")) return;
  var reg={items:[],timer:null};

  function parseIso(root){
    var s=root.getAttribute('data-countdown-date')||'';
    var m=s.trim().match(/^(\d{4})-(\d{2})-(\d{2})\s(\d{1,2}):(\d{2})$/);
    if(!m) return null;
    var y=+m[1],mo=+m[2]-1,d=+m[3],h=+m[4],mi=+m[5];
    var t=Date.UTC(y,mo,d,h,mi,0,0);
    var off=+(root.getAttribute('data-countdown-timezone-offset')||0);
    if(off) t-=off*3600000;
    var dt=new Date(t);
    if(dt.getUTCFullYear()!==y||dt.getUTCMonth()!==mo||dt.getUTCDate()!==d) return null;
    return t;
  }

  function splitByUnits(ms,u){
    var secs=Math.max(0,Math.floor(ms/1000));
    var out={years:0,months:0,weeks:0,days:0,hours:0,minutes:0,seconds:0,done:ms<=0};
    var seq=[['years',31536000],['months',2592000],['weeks',604800],['days',86400],['hours',3600],['minutes',60],['seconds',1]];
    for(var i=0;i<seq.length;i++){
      var k=seq[i][0],len=seq[i][1];
      if(u[k]){ out[k]=Math.floor(secs/len); secs%=len; }
    }
    return out;
  }

  var sing={years:'year',months:'month',weeks:'week',days:'day',hours:'hour',minutes:'minute',seconds:'second'};
  var abbr={years:['yr.','yrs.'],months:['mo.','mos.'],weeks:['wk.','wks.'],days:['day','days'],hours:['hr.','hrs.'],minutes:['min.','mins.'],seconds:['sec.','secs.']};
  function lab(k,v,f){
    if(f==='plain') return ''+v;
    if(f==='short') return v+(k==='months'?'mo':k[0]);
    if(f==='abbr'){ var a=abbr[k]; return v+' '+a[v===1?0:1]; }
    return v+' '+(v===1?sing[k]:k);
  }

  function make(root){
    var u={}, order=['years','months','weeks','days','hours','minutes','seconds'];
    root.querySelectorAll('[data-countdown-update]').forEach(function(n){
      var k=(n.getAttribute('data-countdown-update')||'').toLowerCase();
      if(order.indexOf(k)>-1) u[k]=n;
    });
    var tgt=parseIso(root);
    if(tgt==null){
      root.setAttribute('data-countdown-status','error');
      var first=null; for(var i=0;i<order.length;i++){ if(u[order[i]]){ first=u[order[i]]; break; } }
      if(first) first.textContent='Invalid Date, use: 2026-03-21 11:36';
      order.forEach(function(k){ var n=u[k]; if(n&&n!==first) n.textContent=''; });
      return null;
    }
    var f=(root.getAttribute('data-countdown-format')||'plain').toLowerCase();

    var inst={
      root:root,tgt:tgt,f:f,u:u,st:null,done:false,
      render:function(ms){
        var d=splitByUnits(ms,this.u);
        this.done=d.done;
        this.root.setAttribute('data-countdown-status', d.done?'finished':'active');
        if(this.u.years)   this.u.years.textContent   = lab('years',d.years,this.f);
        if(this.u.months)  this.u.months.textContent  = lab('months',d.months,this.f);
        if(this.u.weeks)   this.u.weeks.textContent   = lab('weeks',d.weeks,this.f);
        if(this.u.days)    this.u.days.textContent    = lab('days',d.days,this.f);
        if(this.u.hours)   this.u.hours.textContent   = lab('hours',d.hours,this.f);
        if(this.u.minutes) this.u.minutes.textContent = lab('minutes',d.minutes,this.f);
        if(this.u.seconds) this.u.seconds.textContent = lab('seconds',d.seconds,this.f);
      },
      tickMin:function(nowMs){
        if(this.done) return;
        this.render(this.tgt-nowMs);
        if(this.u.seconds && !this.done && !this.st) this.startSec();
        if(this.done) this.stopSec();
      },
      startSec:function(){
        var self=this;
        function t(){
          if(self.done) return self.stopSec();
          var ms=self.tgt-Date.now();
          if(ms<=0){ self.render(0); return self.stopSec(); }
          self.render(ms);
        }
        t(); self.st=setInterval(t,1000);
      },
      stopSec:function(){ if(this.st){ clearInterval(this.st); this.st=null; } }
    };
    root.__cd=inst;
    return inst;
  }

  function startMinTimer(){
    if(reg.timer) return;
    reg.timer=setInterval(function(){
      var now=Date.now();
      for(var i=0;i<reg.items.length;i++) reg.items[i].tickMin(now);
    },60000);
    var now=Date.now();
    for(var j=0;j<reg.items.length;j++) reg.items[j].tickMin(now);
  }

  document.querySelectorAll('[data-countdown-date]').forEach(function(root){
    var inst=make(root);
    if(inst) reg.items.push(inst);
  });
  if(reg.items.length) startMinTimer();
}

// Initialize Countdown
document.addEventListener('DOMContentLoaded', () => {
  initCountdown();
  addAllOption();
  select_option2();
});